package com.arena_web.pages.chat

import androidx.compose.runtime.Composable
import com.arena_web.pages.ChatPageContent
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext

@Page("/chat/{id}")
@Composable
fun ChatRoomPage() {
    val ctx = rememberPageContext()
    val chatId = ctx.route.path.substringAfterLast("/")

    ChatPageContent(initialChatId = chatId)
}
